__turbopack_context__.v({
  "fade-in": "CheeseburgerButton-module-scss-module__J931QW__fade-in",
  "fade-up": "CheeseburgerButton-module-scss-module__J931QW__fade-up",
  "open": "CheeseburgerButton-module-scss-module__J931QW__open",
  "root": "CheeseburgerButton-module-scss-module__J931QW__root",
  "showIntro": "CheeseburgerButton-module-scss-module__J931QW__showIntro",
});
